export default {
  props: {
    icon: { type: String, required: true, },
    pulse: { type: Boolean, default: false, },
    type: { type: String, default: 'fas', },
  },
}
